import { render, staticRenderFns } from "./AnalysesCategoriesSection.vue?vue&type=template&id=639b8d0d&scoped=true&"
import script from "./AnalysesCategoriesSection.vue?vue&type=script&setup=true&lang=ts&"
export * from "./AnalysesCategoriesSection.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./AnalysesCategoriesSection.vue?vue&type=style&index=0&id=639b8d0d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639b8d0d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('639b8d0d')) {
      api.createRecord('639b8d0d', component.options)
    } else {
      api.reload('639b8d0d', component.options)
    }
    module.hot.accept("./AnalysesCategoriesSection.vue?vue&type=template&id=639b8d0d&scoped=true&", function () {
      api.rerender('639b8d0d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/diagnostika/analiz/components/AnalysesCategoriesSection.vue"
export default component.exports